import { init } from './init'
import { header } from './header'
import { risk } from './risk'
import { item } from './item'
import { summary } from './summary'
import { dataTransfer } from './dataTransfer'
import { specialFuncUW } from './specialFuncUW'
import { custLog } from './custLog'
import { coinsSvcFee } from './coinsSvcFee'

export const actions = Object.assign({}, init, header, risk, item, summary, dataTransfer, specialFuncUW, custLog, coinsSvcFee)
